module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-popup', {
    staticClass: "AddContactGroup"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": "New Group",
      "closePopup": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('f7-list', {
    attrs: {
      "form": ""
    }
  }, [_c('f7-list-item', [_c('f7-label', [_vm._v("Group name")]), _vm._v(" "), _c('f7-input', {
    attrs: {
      "name": "label",
      "type": "text",
      "placeholder": "Group name"
    },
    model: {
      value: (_vm.label),
      callback: function($$v) {
        _vm.label = $$v
      },
      expression: "label"
    }
  })], 1), _vm._v(" "), _c('li', {}, [_c('a', {
    staticClass: " smart-select smart-select-init",
    attrs: {
      "data-open-in": "page",
      "data-searchbar": "true",
      "data-searchbar-placeholder": "Search contact",
      "data-page-title": "My Contacts",
      "data-back-text": "OK"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selected),
      expression: "selected"
    }],
    attrs: {
      "name": "Debtor Information",
      "multiple": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeItem()
      }]
    }
  }, _vm._l((this.contactSelectionList), function(group, key) {
    return _c('optgroup', {
      attrs: {
        "label": key
      }
    }, _vm._l((group), function(contact, index) {
      return _c('option', {
        domProps: {
          "value": contact.id
        }
      }, [_vm._v(_vm._s(contact.label))])
    }), 0)
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "test-content"
  }, [_c('div', {
    staticClass: "test-inner"
  }, [_c('div', {
    staticClass: "test-title subtitleDebtorList"
  }, [_vm._v("My contacts")]), _vm._v(" "), _c('div', {
    staticClass: "test-after"
  }, [_c('span', {
    staticClass: "button active",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(this.selected.length) + " selected | Edit")])])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "test-content"
  }, [_c('div', {
    staticClass: "test-inner"
  }, [_c('div', {
    staticClass: "test-title subtitleDebtorList",
    staticStyle: {
      "font-size": "17px",
      "color": "black"
    }
  }, [_vm._v("My contacts")]), _vm._v(" "), _c('div', {
    staticClass: "test-after"
  }, [_c('span', {
    staticClass: "button active",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Select")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "white",
      "background-color": "#12bcf1",
      "padding-left": "16px",
      "font-size": "15px",
      "padding": "4px 16px"
    }
  }, [_vm._v("Contacts in this group")]), _vm._v(" "), _c('f7-list', [_c('f7-list-item', {
    attrs: {
      "inner": "",
      "title": "Arianne Poissonnier Home"
    }
  }), _vm._v(" "), _c('f7-list-item', {
    attrs: {
      "title": "Clemence Barrientos Compony"
    }
  }), _vm._v(" "), _c('f7-list-item', {
    attrs: {
      "title": "Didier Matin Company"
    }
  }), _vm._v(" "), _c('f7-list-item', {
    attrs: {
      "title": "Norris Lalonde Company"
    }
  })], 1), _vm._v(" "), _c('f7-button', {
    staticClass: "blueConfirmationButton",
    attrs: {
      "icon-f7": "add_round"
    },
    on: {
      "click": _vm.addContactGroup
    }
  }, [_vm._v("Create")])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7dbe156c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dbe156c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/popups/contacts/CMAddContactGroup.vue
// module id = 1700
// module chunks = 2